import React from 'react';
import PropTypes from 'prop-types';
import CssBaseline from "@material-ui/core/CssBaseline";
import AppBar from "@material-ui/core/AppBar";
import { makeStyles } from "@material-ui/core";
import MenuToolBarLogout from './MenuToolBarLogout';
import MenuDrawerLogout from './MenuDrawerLogout';
const drawerWidth = 270;
// const drawerWidthMobile = 200;
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  drawer: {
    [theme.breakpoints.up('sm')]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    // [theme.breakpoints.up('xs')]: {
    //  // width: `calc(100% - ${drawerWidthMobile}px)`,
    //   marginLeft: drawerWidthMobile,
    // },
    // [theme.breakpoints.up('sm')]: {
    //   width: `calc(100% - ${drawerWidthMobile}px)`,
    //   marginLeft: drawerWidthMobile,
    // },
    // [theme.breakpoints.up('md')]: {
    //   width: `calc(100% - ${drawerWidth}px)`,
    //   marginLeft: drawerWidth,
    // },
    // [theme.breakpoints.up('lg')]: {
    //   width: `calc(100% - ${drawerWidth}px)`,
    //   marginLeft: drawerWidth,
    // },
    // [theme.breakpoints.up('xl')]: {
    //   width: `calc(100% - ${drawerWidth}px)`,
    //   marginLeft: drawerWidth,
    // },
  },
  menuButton: {
    // marginRight: theme.spacing(2),
    // [theme.breakpoints.up('sm')]: {
    //   display: 'none',
    // },
  },
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
  },
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  title: {
    flexGrow: 1,
  },
  toolbarLogo: {
    [theme.breakpoints.up('xs')]: {
      width: 100,
    },
  },
  titleHeader: {
    color: 'rgb(0, 0, 1)',
    fontWeight: 'bold',
    fontSize: '0.875rem'
  }
}));

const ToolbarLogout = props => {
    const { renderContainer } = props

    const classes = useStyles();
    
    const [openSliderDrawer, setSliderDrawer] = React.useState(false);
    const handleSliderDrawerOpen = () => {
      setSliderDrawer(!openSliderDrawer);
    };
  
    const closeSliderDrawer = () => {
      setSliderDrawer(!openSliderDrawer)
    }
  
    return (
      <div className={classes.root}>
        <CssBaseline />
  
        <AppBar
          elevation={0}
          position="fixed"
          className = {classes.appBar} >
          <MenuToolBarLogout
            classes = {classes}
            handleSliderDrawerOpen = { handleSliderDrawerOpen }
          />
        </AppBar>
  
        <MenuDrawerLogout
          // anchor = { 'left' }
          primary = {'#0097a0'}
          open={openSliderDrawer}
          closeDrawer = {closeSliderDrawer}
        />
  
        <main className={classes.content}>
          <div className={classes.toolbar} />
            { renderContainer }
        </main>
      </div>
    );
  };
  
  ToolbarLogout.propTypes = {
    renderContainer:PropTypes.node.isRequired,
  };

export default ToolbarLogout;